/* eslint-disable no-unused-vars */

const getDatahtPlo5 = (key) => {
// eslint-disable-next-line max-len
  const isDev = window.location.host.includes('develop') || window.location.host.includes('localhost');
  const src = isDev ? 'https://develop.omahapro.com/api/lang/tipsplo5' : 'https://omahapro.com/api/lang/tipsplo5';

  try {
    const response = fetch(
      src,
      {
        headers: {
          'Accept-Language': key,
        },
      },
    ).then((data) => data.json()).then((res) => res);

    return response;
  } catch (e) {
    console.log(e);
    return null;
  }
};

export default getDatahtPlo5;
